import React from "react";
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import * as Yup from 'yup'
import {Row, Col, Modal, Icon} from 'antd'
import {Formik, FastField} from 'formik'
import typo from '../../../../constants/dictionaries'
import {isEmpty} from "lodash";

// Utils

// Components
import Input from '../../../Common/Input'
import Button from '../../../Buttons'
import styled from "styled-components";
import ValidatedText from "../../../Common/ValidatedText";

const schema = Yup.object().shape({
  ten: Yup.string().required(typo.cscore_required)
});

class MDSDModal extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }
  render() {
    const {isOpen, handleCancel, handleOk, initialValues, mode, user, isEdit} = this.props;

    return (
      <Modal
        visible={true}
        title={isEdit ? typo.cscore_edit_mucdichsudung : typo.cscore_add_mucdichsudung}
        footer={false}
        onCancel={handleCancel}
        width="500px"
        centered
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(value, actions) => {
            handleOk(value);
            actions.resetForm({});
          }}
          validationSchema={schema}
          render={({handleChange, handleSubmit, values, errors, touched, setFieldValue, dirty}) => (
            <form onSubmit={handleSubmit} autoComplete={false}>
              <Row>
                <FastField name="kyHieu" render={({ field }) => (
                    <Input placeholder={typo.cscore_key} label={typo.cscore_key} mandatory={false} {...field} mode={mode}/>)}/>
                {touched.tenDot && <ValidatedText type="danger">{errors.kyHieu}</ValidatedText>}

                <FastField name="ten" render={({ field }) => (
                    <Input placeholder={typo.cscore_name_mucdichsudung}label={typo.cscore_name_mucdichsudung} {...field} mode={mode}/>)}/>

                <FastField name="moTa" render={({ field }) => (
                    <Input placeholder={typo.cscore_describe}label={typo.cscore_describe} mandatory={false}{...field} mode={mode}/>)}/>
              </Row>
              <div className="mt-20"/>
              {mode !== "presentation" &&
              <Row type="flex" justify="end" align="middle">
                <Button type="submit" onClick={handleSubmit} disabled={!isEmpty(errors)}><Icon type="save"/>{typo.cscore_save}</Button>
                <div className="ml-10"/>
                <Button type="cancel" onClick={handleCancel}><Icon type="arrow-left" />{typo.cscore_back}</Button>
              </Row>}
              {/*<DisplayFormikState error={errors} value={values} touched={touched}/>*/}
            </form>
          )}/>
      </Modal>
    )
  }
}
MDSDModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  /*Mode: add, edit, presentation*/
  mode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(MDSDModal)

const GroupWrapper = styled.div`
  max-width: 80%;
  padding: 5px 10px; 
`;

